module.exports = "<div class=\"row\">\n  <div class=\"col-md-12\">\n    <canvas baseChart height=\"80\" [datasets]=\"attendanceChartData\" [labels]=\"attendanceChartLabels\" [options]=\"attendanceChartOptions\" [legend]=\"attendanceChartLegend\"\n      [chartType]=\"attendanceChartType\" [colors]=\"attendanceChartColors\"></canvas>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/reports/components/timesheet/attendance/attendance.component.html
// module id = ./src/app/modules/reports/components/timesheet/attendance/attendance.component.html
// module chunks = main